<template>
    <div class="container" style="border-top:0px">
	  <!-- 我的订单  v-if="activeindex == 8"-->
	 <!-- 优惠券 -->
	 <div class="certificate">
	 	<div class="cerlist">
	 		<div class="title">甘肃省专业技术人员继续教育培训证书申请</div>
	 		<div class="time zhengshulist">
	 			<span>1、按人社厅要求证书统一由"甘肃省专业技术人员继续教育工作平台"管理发放；</span><br />
	 			<span>2、请在确认自己完成培训学习后（公需课学时满30学时，总学时满90学时），点击下面"提交学时，申请证书"按钮；</span><br/>
        <span>3、学时提交成功后，请登录"甘肃人社公共服务平台"（<a
            href="https://wsbs.rst.gansu.gov.cn/publicservice/home"
            target="_blank">https://wsbs.rst.gansu.gov.cn/publicservice/home</a>），点击<i>“个人办事”-“我要查”-“人才人事”-“继续教育”-“学时认定证书查询”</i>，进行证书查询和下载打印。</span>
	 			<span><br/>
				<span>4、系统管理员在每周五18点提交本周内的证书申请信息，提交后及时关注"甘肃人社公共服务平台"查询证书；</span><br/>	
          
	 				<button class="certificatebtn" @click="submitcert()"><img	src="../../assets/img/our/grzx_ck.svg" alt="" />提交学时，申请证书</button>
	 			</span>
	 		</div>
	 	</div>
	 </div>
	 <el-dialog title="填写证书申请信息" :visible.sync="open" width="800px" append-to-body>
		 
		<el-form ref="form" :model="form" :rules="rules" label-width="110px">
		   <el-divider content-position="center">报名信息</el-divider>
		   <el-form-item label="单位名称" prop="aab004">
		      <el-input v-model="form.aab004" placeholder="输入单位名称" />
		   </el-form-item>
		   <el-form-item label="学历信息" prop="aac011" style="width: 100%;">
		     <el-select v-model="form.aac011" placeholder="请选择学历" style="width: 100%;">
		       <el-option
		         v-for="dict in dicValue.AAC011"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   <el-form-item label="学位信息" prop="aac037" style="width: 100%;">
		     <el-select v-model="form.aac037" placeholder="请选择学位" style="width: 100%;">
		       <el-option
		         v-for="dict in dicValue.AAC037"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   <el-divider content-position="center">取得职称证书或职业资格证书</el-divider>
		   <el-form-item label="是否得证书" prop="agc381" style="width: 100%;">
		     <el-select v-model="form.agc381" placeholder="请选择是否取得职称证书或职业资格证书" style="width: 100%;" @change="changeAGC381()">
		       <el-option
		         v-for="dict in dicValue.AGC381"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   <el-form-item label="取得证书类型" class="is-required" prop="agc380" style="width: 100%;" v-if="form.agc381 == '1'">
		     <el-radio-group v-model="form.agc380" style="width: 100%;"  @change="changeAGC380()">
		       <el-radio
		         v-for="dict in dicValue.AGC380"
		         :key="dict.dictValue"
		          :label="dict.dictValue"
		       >{{dict.dictLabel}}</el-radio>
		     </el-radio-group>
		   </el-form-item>
		   <el-divider content-position="center">取得职称信息</el-divider>
		   <el-form-item label="职称系列" class="is-required" prop="age002" style="width: 100%;" v-if="form.agc380 == '1' && form.agc381 == '1'">
		     <el-select v-model="form.age002" placeholder="请选择职称系列" style="width: 100%;"  @change="changePartAAC200()">
		       <el-option
		         v-for="dict in dicValue.AGE002"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   <el-form-item label="职称名称" class="is-required" prop="aac200" style="width: 100%;" v-if="form.agc380 == '1' && form.agc381 == '1'">
		     <el-select v-model="form.aac200" placeholder="请选择职称名称" style="width: 100%;">
		       <el-option
		         v-for="dict in partAAC200"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   <el-form-item label="职称级别" class="is-required" prop="age013" style="width: 100%;" v-if="form.agc380 == '1' && form.agc381 == '1'">
		     <el-select v-model="form.age013" placeholder="请选择职称级别" style="width: 100%;">
		       <el-option
		         v-for="dict in dicValue.AGE013"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   <el-form-item label="职业资格名称" class="is-required" prop="agc164" style="width: 100%;" v-if="form.agc380 == '2' && form.agc381 == '1'">
		     <el-select v-model="form.agc164" placeholder="请选择职业资格名称" style="width: 100%;">
		       <el-option
		         v-for="dict in dicValue.AGC164"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   <el-form-item label="职业资格等级" class="is-required" prop="age618" style="width: 100%;" v-if="form.agc380 == '2' && form.agc381 == '1'">
		     <el-select v-model="form.age618" placeholder="请选择职业资格等级" style="width: 100%;">
		       <el-option
		         v-for="dict in dicValue.AGE618"
		         :key="dict.dictValue"
		         :label="dict.dictLabel"
		         :value="dict.dictValue"
		       ></el-option>
		     </el-select>
		   </el-form-item>
		   
		   
		   <div  class="dialog-footer" align="right">
		      <el-button type="primary" @click="submitCreditHours">提交证书申请</el-button>
		      <el-button @click="cancel">取 消</el-button>
		   </div>
		</el-form>
	 </el-dialog>
	 <div  style="width:100%">
	 	<el-table :data="cert_list"  style="width: 100%">
	 		<el-table-column
	 		  label="证书申请提交记录"
	 		  align="center"
	 		  >
				  <el-table-column prop="agz353" align="center" label="操作" width="200">
				  	<template slot-scope="scope">
						<span v-if="scope.row.agz353 == '1'">公需课</span>
						<span v-if="scope.row.agz353 == '2'">专业课</span>
					</template>
				  </el-table-column>
				  <el-table-column
				  	prop="aae001"
				  	label="年份"
				   >
				  </el-table-column>
	 			  <el-table-column
	 				prop="bged12"
	 				label="培训开始时间">
	 			  </el-table-column>
	 			  <el-table-column
	 				prop="bged13"
	 				label="培训结束时间">
	 			  </el-table-column>
	 			  <el-table-column
	 				prop="agz377"
	 				label="学时">
	 			  </el-table-column>
	 			  <el-table-column
	 				prop="createTime"
	 				label="创建时间">
	 			  </el-table-column>
	 			</el-table-column>
	 	  </el-table>
        
	 </div>
	 <pagination style="float: left;padding-left: 35%;" v-if="total > 0" :total="total"
	 	:display='queryParams.pageSize' :current-page='queryParams.pageNum'
	 	@pagechange="pageCourseChange"></pagination>


    </div>
</template>

<script>
	import pagination from '@/components/common/pagination'
	import {startReport,queryClazzList,submitStudyHonours,getUserCertRecordList} from '@/api/clazz.js'
	import {getDicts} from '@/api/dict/data.js'
	
	export default {
	  components: {
	  	pagination,
	  },
	  data() {
	    return {
			dict:['AGE002', 'AGE013', 'AGC380', 'AGC381', 'AGE618', 'AAC058', 'AGZ353', 'AAC200', 'AAC011', 'AAC037', 'AGC164', 'pxnf'],
			dicValue:{
				AGE002:[],
				AGE013:[],
				AGC380:[],
				AGC381:[],
				AGE618:[],
				AAC058:[],
				AGZ353:[],
				AAC200:[],
				AAC011:[],
				AAC037:[],
				AGC164:[],
				pxnf:[]	
			},
		    my_money_coupons_list: [],
	        order_list: [],
			open:false,
	        queryOrderParams: {
	       	  pageNum: 1,
	       	  pageSize: 10,
	        },
			queryParams:{
				pageNum: 1,
				pageSize: 10,
				year:null
			},
	        order_total: 0,
		    isShowMyPay: false,
		    currentYear:null,
			cert_list:[],
			total: 1,
			form:{
				aac003: null,
				aac058: null,
				aac147: null,
				aab004: null,
				aae001: null,
				agz353: null,
				agz361: null,
				bged12: null,
				bged13: null,
				agz377: null,
				bge082: null,
				aac011: null,
				aac037: null,
				agc381: null,
				agc380: null,
				age002: null,
				aac200: null,
				age013: null,
				agc164: null,
				age618: null,
				year: null
			},
			index:100000,
			rules: {
			  aab004: [
			    { required: true, message: "单位名称必须填写", trigger: "change" }
			  ],
			  agc381: [
			    { required: true, message: "是否取得职称证书或职业资格证书为必选项", trigger: "change" }
			  ],
			},
			partAAC200:[]
	    }
	  },
	  created() {
		this.currentYear = localStorage.getItem('year');
		this.getDictList();
		this.getUserCertRecordList();
	  },
	  methods: {
		  //是否取得证书
		  changeAGC381(){
		  	var me = this;
		    if(me.form.agc381 == null || me.form.agc381 =='0'){
		  		me.form.agc380 = null;
		  		me.form.age002 = null;
		  		me.form.aac200 = null;
		  		me.form.age013 = null;
		  		me.form.agc164 = null;
		  		me.form.age618 = null;
		  	}	  
		  },
		  //取的证书类型
		  changeAGC380(){
		  	 var me = this;
		  	 me.form.age002 = null;
		  	 me.form.aac200 = null;
		  	 me.form.age013 = null;
		  	 me.form.agc164 = null;
		  	 me.form.age618 = null;  
		  },
		  changePartAAC200(){
		  	var me = this;
		  	if(this.form.age002 != null && this.form.age002 != ''){
		  		me.partAAC200 = [];
		  		this.form.aac200 =null;
		  		for(var i = 0;i<me.dicValue.AAC200.length;i++){
		  			if(me.dicValue.AAC200[i].dictValue?.startsWith(me.form.age002) == true ||  me.dicValue.AAC200[i].dictValue =='9901'){
		  				me.partAAC200.push(me.dicValue.AAC200[i]);
		  			}
		  		}
		  	}		  
		  },
		  submitcert(){
			this.open = true;  
		  },
		  cancel(){
			  this.open = false;
		  },
		  getDictList(){
			var me = this;
			for(let i = 0;i<me.dict.length;i++){
				this.index = i;
				getDicts(me.dict[this.index]).then(response => {
					if (response.code == 200) {
						//me.cert_list = response.data;
						if(me.dict[i] == 'AGE002'){
							console.log(response.data)
							me.dicValue.AGE002 = response.data;
						}
						if(me.dict[i] == 'AGE013'){
							me.dicValue.AGE013 = response.data;
						}
						if(me.dict[i] == 'AGC380'){
							me.dicValue.AGC380 = response.data;
						}
						if(me.dict[i] == 'AGC381'){
							me.dicValue.AGC381 = response.data;
						}
						if(me.dict[i] == 'AGE618'){
							me.dicValue.AGE618 = response.data;
						}
						if(me.dict[i] == 'AAC058'){
							me.dicValue.AAC058 = response.data;
						}
						if(me.dict[i] == 'AGZ353'){
							me.dicValue.AGZ353 = response.data;
						}
						if(me.dict[i] == 'AAC200'){
							me.dicValue.AAC200 = response.data;
						}
						if(me.dict[i] == 'AAC011'){
							me.dicValue.AAC011 = response.data;
						}
						if(me.dict[i] == 'AAC037'){
							me.dicValue.AAC037 = response.data;
						}
						if(me.dict[i] == 'AGC164'){
							me.dicValue.AGC164 = response.data;
						}
						
	
						
					}
				});  
			}
			console.log(me.dicValue);

		  },
		  
		  pageCourseChange(currentPage) {
		  	console.log(currentPage);
		  	this.queryParams.pageNum = currentPage;
		  	// ajax请求, 向后台发送 currentPage, 来获取对应的数据
		  	this.getUserCertRecordList();
		  },
		  //查询证书
		  getUserCertRecordList(){
			 var me = this;
			 this.queryParams.year = localStorage.getItem('year')
			 getUserCertRecordList(this.queryParams).then(response => {
				if (response.code == 200) {
					this.cert_list = response.rows;
					this.total = response.total
				}
			 });  
		  },
		  submitCreditHours() {
		  	var me = this;
			this.$refs["form"].validate(valid => {
			    if (valid) {
				
					if(me.form.agc381 == '1'){
						if(me.form.agc380 == null || me.form.agc380 == ''){
							this.$message({
							    showClose: true,
							    message: '当是否取得职称证书或职业资格证书选“是”时，取得证书类型该项为必填项',
							    type: 'error'
							});
							return;
						}
						//选择职称类型
						if(me.form.agc380 == '1'){
							if(me.form.age002 == null || me.form.age002 == ''){
								this.$message({
								    showClose: true,
								    message: '当取得证书类型选“职称证书”时，职称系列该项为必填项',
								    type: 'error'
								});
								return;
							}
							if(me.form.aac200 == null || me.form.aac200 == ''){
								this.$message({
								    showClose: true,
								    message: '当取得证书类型选“职称证书”时，职称名称该项为必填项',
								    type: 'error'
								});
								return;
							}
							if(me.form.age013 == null || me.form.age013 == ''){
								this.$message({
								    showClose: true,
								    message: '当取得证书类型选“职称证书”时，职称级别该项为必填项',
								    type: 'error'
								});
								return;
							}
							
						}
						//选择职业资格类型
						if(me.form.agc380 == '2'){
							if(me.form.agc164 == null || me.form.agc164 == ''){
								this.$message({
								    showClose: true,
								    message: '当取得证书类型选“职业资格证书”时，职业资格名称必填项',
								    type: 'error'
								});
								return;
							}
							if(me.form.age618 == null || me.form.age618 == ''){
								this.$message({
								    showClose: true,
								    message: '当取得证书类型选“职业资格证书”时，职业资格等级该项为必填项',
								    type: 'error'
								});
								return;
							}
							
						}
						
					}
					me.form.year = localStorage.getItem('year');
					submitStudyHonours(me.form).then(response => {
						if (response.code == 200) {
							this.open = false;
							me.$message.success('提交成功！');
							me.getUserCertRecordList();
						}
					});
			    }
			})
			
		  },
		  submitCreditHours2() {
		  	var me = this;
			
			this.$refs["form"].validate(valid => {
			    if (valid) {
				    var js = {
				    	year: localStorage.getItem('year')
				    }
				    submitStudyHonours(js).then(response => {
				    		  
				    	if (response.code == 200) {
				    		var obj = JSON.parse(response.info);
				    		if (obj.code == 0) {
				    			me.$message.success('提交成功！');
				    			me.queryClazzList();
				    			return;
				    		} else {
				    			alert(obj.msg);
				    			//this.$message.fail(obj.msg);
				    		}
				    	}
				    		  
				    		  
				    });
				  
				}
			})
		  	
		  },

		pageChange(currentPage) {
			console.log(currentPage);
			this.queryOrderParams.pageNum = currentPage;
			// ajax请求, 向后台发送 currentPage, 来获取对应的数据
			this.queryCouponsList();
		},
	    handleChange(view) {
	      this.$nextTick(() => {
	        // 可在此处添加切换逻辑
	      })
	    }
	  }
	}
</script>

<style lang="less" scoped>

	.certificate {
		//border-top: 1px dashed #dcdcdc;
		padding-top: 27px;
		display: flex;
		//width:500px;
		flex-wrap: wrap;

		.cerlist {
			border-radius: 5px 5px 5px 5px;
			background: #f7f8fa;
			padding: 17px 17px 17px 24px;
			margin-right: 15px;
			margin-bottom: 28px;

			&:nth-child(3n) {
				margin-right: 0;
			}

			.title {
				font-size: 18px;
				font-weight: 600;
				margin: 0 auto;
				color: #333333;
				margin-bottom: 10px;
			}

			.time {
				font-size: 16px;
				color: #777777;

				img:nth-child(1) {
					margin-left: 80px;
					margin-right: 12px;
				}
        i{
          color: #ff3300;
        }
			}
		}
	}
	.component-wrapper {
	  margin-top: 20px;
	 // border: 1px solid #ebeef5;
	  padding: 20px;
	  border-radius: 4px;
	}
  .certificatebtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 10px 0 0;
    padding: 8px 15px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    //cursor: allowed;
    cursor: pointer;
    color: #ff6a00;

    img {
      margin: 0 5px 0 0 !important;
    }
  }
</style>
